import React from 'react';
import {
  CalendarEventType,
  CALENDAR_EVENT_TYPES,
  EVENT_TYPE_LABELS,
  EVENT_TYPE_COLORS,
} from '../../types/calendar';

interface CalendarEventTypeFilterProps {
  selectedTypes: CalendarEventType[];
  onToggle: (type: CalendarEventType) => void;
}

const CalendarEventTypeFilter: React.FC<CalendarEventTypeFilterProps> = ({
  selectedTypes,
  onToggle,
}) => {
  return (
    <div className="flex items-center space-x-2 flex-wrap gap-y-1">
      <span className="text-xs text-gray-500 mr-1">Types:</span>
      {CALENDAR_EVENT_TYPES.map(type => {
        const colors = EVENT_TYPE_COLORS[type];
        const isSelected = selectedTypes.includes(type);

        return (
          <button
            key={type}
            onClick={() => onToggle(type)}
            className={`inline-flex items-center space-x-1.5 px-2 py-1 rounded-full text-xs font-medium transition-all ${
              isSelected
                ? `${colors.bg} ${colors.text} border ${colors.border}`
                : 'bg-gray-100 text-gray-400 border border-gray-200 line-through'
            }`}
            aria-pressed={isSelected}
            aria-label={`${isSelected ? 'Hide' : 'Show'} ${EVENT_TYPE_LABELS[type]}`}
          >
            <div className={`w-2 h-2 rounded-full ${isSelected ? colors.dot : 'bg-gray-300'}`} />
            <span>{EVENT_TYPE_LABELS[type]}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CalendarEventTypeFilter;
